angular.module('zc.projects')
  .directive('zcItemListPriceConfirm', zcItemListPriceConfirm);

zcItemListPriceConfirm.$inject = ['$filter', 'BaseProjectConfirm'];
function zcItemListPriceConfirm($filter, BaseProjectConfirm) {
  const confirm = new BaseProjectConfirm($filter('translate')('projectsSettings.other.itemListPriceConfirm.productList'), ['item_list_price']);
  return confirm.createDirective(confirm.requestRecentHistories);
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/other/item_list_price_confirm.directive.js